/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from "react";
import { Helmet } from "react-helmet-async";

import Header1 from "parts/Header1";
import EMShero from "parts/EMSHero";
import Thechallenge from "parts/Thechallenge";
import SeeAction from "parts/SeeAction";
import WhoItsFor from "parts/Whoitsfor";
import Footer from "parts/Footer";
import Theplatform from "parts/Platform";
import HowEngage from "parts/HowEngage";
import TestimonialEms from "parts/TestimonialEms";
import WhyNube from "parts/WhyNube";
import CTAEms from "parts/CTAEms";

export default class EMSPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Helmet>
          <title>
            EMS | Get a Demo
          </title>
          <meta
            name="description"
            content="Talk to our team about your building automation goals or schedule a live demo."
          />
          <meta
            name="keywords"
            content="building automation contact, demo smart BMS, IoT consultation"
          />
          <link rel="canonical" href="https://nube-io.com/contact/ " />
          <meta
            property="og:title"
            content="EMS | Get a Demo"
          />
          <meta
            property="og:description"
            content="Talk to our team about your building automation goals or schedule a live demo."
          />
          <meta property="og:url" content="https://nube-io.com/co/" />
        </Helmet>
        <Header1 />
        <EMShero />
        <Thechallenge />
        <SeeAction />
        <Theplatform />
        <WhoItsFor />
        <TestimonialEms />
        <HowEngage />
        <WhyNube />
        <CTAEms />
        <Footer />
      </>
    );
  }
}
